import { useLayoutEffect } from 'react';
import { QueryParams } from '@/constants/QueryParam';
import { parseFeatureFlagsQueryParam } from '@/featureFlags/parseFeatureFlagsQueryParam';
import { useQueryParam } from '@/hooks/useQueryParam/useQueryParam';
import { useFeatureFlagOverridesStore } from '@/store/featureFlagOverridesStore';
import { environment } from '@/utils/env.utils';

const useApplyFeatureFlagQueryParam = () => {
  const featureFlagsParam = useQueryParam(QueryParams.FEATURE_FLAGS);

  useLayoutEffect(() => {
    if (environment.env === 'production') {
      return;
    }

    const parsed = parseFeatureFlagsQueryParam(featureFlagsParam);
    if (Object.keys(parsed).length === 0) {
      return;
    }

    const { overrides, mergeOverrides } = useFeatureFlagOverridesStore.getState();
    const hasChanges = Object.entries(parsed).some(([key, value]) => overrides[key] !== value);
    if (!hasChanges) {
      return;
    }

    mergeOverrides(parsed);
  }, [featureFlagsParam]);
};

export default useApplyFeatureFlagQueryParam;
